import React from 'react'

interface ViewItemProps {
    icon: React.ComponentType<{ className?: string }>;
    color: string;
    bgColor: string;
    title: string;
    description: string;
}

export function ViewItem({ icon: Icon, color, bgColor, title, description }: ViewItemProps) {
    return (
        <button className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 text-left group transition-colors">
            <div className={`w-8 h-8 rounded flex items-center justify-center flex-shrink-0 ${bgColor}`}>
                <Icon className={`w-5 h-5 ${color}`} />
            </div>
            <div className="min-w-0">
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400">{title}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{description}</div>
            </div>
        </button>
    )
}

interface ViewItemSimpleProps {
    icon: React.ComponentType<{ className?: string }>;
    color: string;
    title: string;
    description?: string;
}

export function ViewItemSimple({ icon: Icon, color, title, description }: ViewItemSimpleProps) {
    return (
        <button className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 text-left group transition-colors">
            <div className="w-8 h-8 rounded bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0">
                <Icon className={`w-5 h-5 ${color}`} />
            </div>
            <div className="min-w-0">
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400">{title}</div>
                {description && <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{description}</div>}
            </div>
        </button>
    )
}
